export default {
  creditCard: 'creditCard',
  paypal: 'paypal',
};
